import axios from 'axios';

export const apiAws = axios.create({
    //baseURL: 'http://127.0.0.1:3001/',
    //baseURL: 'https://g7vwizx3vg.execute-api.us-east-1.amazonaws.com/Prod',
    baseURL: 'https://o1jplxpk31.execute-api.us-east-1.amazonaws.com/Prod', //produção
});